function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.46,0A12.46,12.46,0,1,0,24.91,12.46,12.46,12.46,0,0,0,12.46,0Zm0,24.16a11.71,11.71,0,1,1,11.7-11.7A11.72,11.72,0,0,1,12.46,24.16Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.68,11.22c0-.33-.09-.62-.13-.9-.14-.91-.24-1.58,0-1.82s.61-.61.34-1L8.76,7.3c-.16-.25-.35-.55-.49-.73a.49.49,0,0,0-.38-.23.67.67,0,0,0-.4.19l-.08.06a2,2,0,0,0-.67,2.55l.11.31a16.12,16.12,0,0,1,1.08,4.13c0,1.12-.76,1.66-2.33,1.66A2,2,0,0,1,4,14.66a1.4,1.4,0,0,1-.06-1.27.31.31,0,0,0,0-.28.3.3,0,0,0-.49,0,2.19,2.19,0,0,0,.09,2.67,2.32,2.32,0,0,0,2,1h0a3.79,3.79,0,0,0,2.6-1.06C8.76,15,9.11,14.46,8.68,11.22Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.83,9.12a2,2,0,0,0,.71,2.14,3.82,3.82,0,0,0,1,.47.87.87,0,0,1,.63.5,1.57,1.57,0,0,1,.17,1,.28.28,0,0,0,.06.25.32.32,0,0,0,.24.11.29.29,0,0,0,.27-.18,2.87,2.87,0,0,0-.06-2.07A3.32,3.32,0,0,0,9.17,8.89h0A.3.3,0,0,0,8.83,9.12Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.33,12.81a2.94,2.94,0,0,0-1.59-.47,2.54,2.54,0,0,0-2.27,1.36.29.29,0,0,0,.26.42.28.28,0,0,0,.2-.1,1.91,1.91,0,0,1,1.44-.54,2.49,2.49,0,0,1,1.36.36c-.25,0-.54.1-.8.17l-.22.06A6.73,6.73,0,0,1,16,14.4c-.53,0-1.06,0-1.06-2,0-.37,0-.71,0-1,0-1.49.07-2.66-.81-3.58a.28.28,0,0,0-.48.14,2.08,2.08,0,0,0-.05.34l0,.22c-.09,1.09-.33,4-1.85,5.49A9.93,9.93,0,0,1,8,16.15a.27.27,0,0,0-.2.3A.28.28,0,0,0,8,16.7l.43,0a5.57,5.57,0,0,0,3.7-1.37,6.66,6.66,0,0,0,1.73-2.76c0,.32,0,.63,0,.89a2.78,2.78,0,0,0,.48,2.1,1.82,1.82,0,0,0,1.41.54,4.72,4.72,0,0,0,1.85-.46A8.2,8.2,0,0,1,21,15a.28.28,0,0,0,.24-.13l.68-1.05a.3.3,0,0,0,0-.29.29.29,0,0,0-.25-.15h-.42A3.27,3.27,0,0,1,20,13.14C19.73,13,19.53,12.92,19.33,12.81Z"
});

function SvgHalal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    fill: "currentColor",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.91 24.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalal);
export default __webpack_public_path__ + "static/media/Halal.d9cb8710.svg";
export { ForwardRef as ReactComponent };